import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { AppShell } from '@/components/layout/AppShell';
import { AuthProvider } from '@/context/AuthContext';
import { BalanceBillsPage } from '@/pages/BalanceBillsPage';
import { BillsPage } from '@/pages/BillsPage';
import { BookingsPage } from '@/pages/BookingsPage';
import { CashBookPage } from '@/pages/CashBookPage';
import { ComingSoonPage } from '@/pages/ComingSoonPage';
import { CondimentsPage } from '@/pages/CondimentsPage';
import { CustomersPage } from '@/pages/CustomersPage';
import { ExpenseLedgerPage } from '@/pages/ExpenseLedgerPage';
import { HappyHourPage } from '@/pages/HappyHourPage';
import { LoginPage } from '@/pages/LoginPage';
import { ManageCondimentsPage } from '@/pages/ManageCondimentsPage';
import { ManageTablesPage } from '@/pages/ManageTablesPage';
import { PaymentsPage } from '@/pages/PaymentsPage';
import { ReportsPage } from '@/pages/ReportsPage';
import { TablesPage } from '@/pages/TablesPage';
import { RequireAuth, RequireModule } from './RouteGuards';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="login" element={<LoginPage />} />
          <Route element={<RequireAuth />}>
            <Route element={<AppShell />}>
              <Route index element={<RequireModule module="tables"><TablesPage /></RequireModule>} />
              <Route path="bookings" element={<RequireModule module="tables"><BookingsPage /></RequireModule>} />
              <Route path="bills" element={<RequireModule module="bills"><BillsPage /></RequireModule>} />
              <Route path="bills/balance" element={<RequireModule module="bills"><BalanceBillsPage /></RequireModule>} />
              <Route path="bills/payments" element={<RequireModule module="reports"><PaymentsPage /></RequireModule>} />
              <Route path="condiments" element={<RequireModule module="condiments"><CondimentsPage /></RequireModule>} />
              <Route path="customers" element={<RequireModule module="customers"><CustomersPage /></RequireModule>} />
              <Route path="ledgers" element={<Navigate to="/ledgers/cash" replace />} />
              <Route path="ledgers/cash" element={<RequireModule module="ledgers"><CashBookPage /></RequireModule>} />
              <Route path="ledgers/expenses" element={<RequireModule module="ledgers"><ExpenseLedgerPage /></RequireModule>} />
              <Route path="manage/tables" element={<RequireModule module="settings"><ManageTablesPage /></RequireModule>} />
              <Route path="manage/condiments" element={<RequireModule module="settings"><ManageCondimentsPage /></RequireModule>} />
              <Route path="reports" element={<RequireModule module="reports"><ReportsPage /></RequireModule>} />
              <Route path="settings" element={<Navigate to="/settings/happy-hour" replace />} />
              <Route path="settings/happy-hour" element={<RequireModule module="settings"><HappyHourPage /></RequireModule>} />
              <Route path="*" element={<ComingSoonPage title="Not found" />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
